import axios from './axios'
import { CreatePosClosingDto, PosClosingDto, PosClosingPreviewDto } from './types'

export const getPosClosings = (params?: { posId?: string }) => {
  return axios.get<PosClosingDto[]>('/pos-closings', { params })
}

export const getPosClosing = (id: string) => {
  return axios.get<PosClosingDto>(`/pos-closings/${id}`)
}

export const previewPosClosing = (data: CreatePosClosingDto) => {
  return axios.post<PosClosingPreviewDto>('/pos-closings/preview', data)
}

export const createPosClosing = (data: CreatePosClosingDto) => {
  return axios.post<PosClosingDto>('/pos-closings', data)
}
